var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","small":"","text":"","title":"Lista de contatos"},on:{"click":_vm.contatos}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-contacts")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }